import React from "react";

const Digital = () => {
  return (
    <div className=" text-white flex flex-col justify-center items-center text-center py-10 px-4">
      {/* Heading */}
      <h1 className="text-4xl md:text-5xl font-bold mb-10">
        Join us in your digital journey and be the next success story!
      </h1>

      {/* Subtext */}
      <p className="text-gray-300 max-w-2xl mb-20">
        These success stories are a testament to the dedication and expertise of
        our team at Multify Solutions Pvt. Ltd. We are driven by a commitment to
        delivering outstanding results and helping businesses flourish in the
        digital landscape.
      </p>

      {/* CTA Text */}
      <p className="text-lg font-medium mb-10">
        Unlock Your Digital Potential Today
      </p>

      {/* Buttons */}
      <div className="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0">
        <button className="px-6 py-3 rounded-full border-2 border-[#4C22E5] bg-white text-black font-semibold hover:bg-gray-200 transition">
          Get Started
        </button>

        <button className="px-6 py-3 rounded-full border-2 border-[#4C22E5] text-white font-semibold bg-gradient-to-r from-[#2A0F85] to-[#4C22E5] hover:opacity-80 transition">
          Free Consultation
        </button>
      </div>
    </div>
  );
};

export default Digital;
